"use strict";

const SoaModel = require('bunsen/models/SoaModel');
const Seller = require('bunsen/models/Seller');
const User = require('bunsen/models/identity/User');
const assert = require('bunsen/helpers/assert');
const _userTypes = {
    user : 'USER',
    seller : 'SELLER'
};

/**
 * This version of the authorized role checks against a user or seller's ID.
 * @type {Function}
 */
const AuthorizedUserRole = SoaModel.extend({

    /**
     * Determines whether or not a given user has all the permissions present in the authorized role.
     * @param userOrSeller
     * @returns {*}
     */
    isPermitted(userOrSeller) {
        let errMsg = 'isPermitted requires a real instance of a user or seller model';
        assert((userOrSeller instanceof User) || (userOrSeller instanceof Seller), errMsg);
        return this.get('id') === userOrSeller.get('id');
    },

    // determines if the auth role matches gainst a seller
    isRoleSeller() {
        return this.get('userType') === _userTypes.seller;
    },

    // determines whether the auth role is for a user (as opposed to seller)
    isRoleAdmin() {
        return this.get('userType') === _userTypes.user;
    }

});

module.exports = AuthorizedUserRole;


AuthorizedUserRole.userTypes = _userTypes;



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/AuthorizedUserRole.es.js